import React from 'react';
import NFTListing from '@/Component/NFTListing';
import HeroBlock from '../Component/HeroBlock';
import StadiumBlock, { StadiumBlockProps } from '../Component/StadiumBlock';
import { SoldItemCountDetails } from '@/lib/providers/NftContextProvider';

export interface HeroBlockProps {
  title: string;
  subTitle: string;
  description: string;
  imageURL: string;
  isLogged?: boolean;
  hyberLinkTitle?: string;
}
export interface SubHeaderBlockProps {
  title: string;
  description: string;
}

export interface CollectionBlockData {
  title: string;
  description: string;
  show: boolean;
}

export type TokenDetails = {
  isLoading: boolean;
  tokensUsed: number;
  totalTokens: number;
  soldCount: number;
};

type Props = {
  isSaleStarted: boolean;
  isSaleEnded: boolean;
  heroBlock: HeroBlockProps;
  stadiumBlock?: StadiumBlockProps;
  tokenDetails: TokenDetails;
  soldItems: SoldItemCountDetails[];
};

const HomeLayout: React.FC<Props> = ({
  isSaleStarted,
  isSaleEnded,
  heroBlock,
  stadiumBlock,
  tokenDetails,
  soldItems
}) => {
  return (
    <div
      style={{
        flex: 1
      }}
    >
      <HeroBlock
        isSaleStarted={isSaleStarted}
        isSaleEnded={isSaleEnded}
        description={heroBlock.description}
        imageURL={heroBlock.imageURL}
        subTitle={heroBlock.subTitle}
        title={heroBlock.title}
        hyberLinkTitle={heroBlock?.hyberLinkTitle}
        tokenDetails={tokenDetails}
        soldItems={soldItems ?? []}
      />
      {stadiumBlock && (
        <StadiumBlock
          title={stadiumBlock?.title}
          description={stadiumBlock?.description}
          imageURL={stadiumBlock?.imageURL}
        />
      )}
      <NFTListing title="Browse Our Exclusive NFT Collection" />
    </div>
  );
};

export default HomeLayout;
